module.exports = __webpack_public_path__ + "img/3.c4487c8e.jpg";